import { ApiService } from './../../api.service';
import { Entity } from './../select-list/select-list.component';
import { Component, OnInit } from '@angular/core';
import { MyUtility } from '../../comparison';

@Component({
  selector: 'app-geographic-categories',
  templateUrl: './geographic-categories.component.html',
  styleUrls: ['./geographic-categories.component.css']
})
export class GeographicCategoriesComponent implements OnInit {

  public updater: any;
  public title : string;
  
  constructor(public api: ApiService) {
   }

  ngOnInit() {
    if(this.selectedItem)
      this.updater();
  }

  clearCurrent(){
    this.api.session.currentCriteria.regions = MyUtility.deepCopy(this.api.originalCriteria.regions);
    this.updater();
  }

  get items(){
    return this.api.session.geoCategories;
  }


  get selectedItem() {
    return this.api.session.currentCriteria.regions.selectedCategory;
  }
  set selectedItem(value) {
    MyUtility.scrubChildren(value);
    console.log("selectedItem setter: " + JSON.stringify(value));
    this.api.session.currentCriteria.regions.selectedItems = [];
    this.api.session.currentCriteria.regions.selectedCategory = value;
    this.updater();
  }
}
